export default "__VITE_ASSET__DaPfD_Yp__"